<template>
  <v-card v-if="customerReward">
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        {{ title }}
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn
        v-if="rewardIsStuck"
        class="mr-3"
        color="primary"
        :loading="isRetrying"
        @click="retryReward"
        :disabled="isArchived"
      >
        <v-icon color="light-blue lighten-4">mdi-sync</v-icon>
        Retry Reward
      </v-btn>
      <!-- <v-spacer v-if="rewardIsStuck"></v-spacer> -->
      <!-- <v-btn color="primary" :loading="isArchiving" :disabled="isArchived" @click="toggleActivity">
        <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
        Archive customerReward
      </v-btn> -->
      <!-- <v-btn color="primary ml-3" :loading="isRestoring" v-if="isArchived" @click="restorecustomerReward">
        <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
        Restore
      </v-btn> -->
    </v-toolbar>

    <!-- customerReward info -->
    <v-divider />
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" md="2" aria-rowspan="2">
          <h2 class="subtitle-2 text-uppercase">Info</h2>
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Amount (Euro)" :value="transactionKey('amount_in_euros')" type="date" />
        </v-col>
        <v-col cols="12" md="2">
          <key-value
            title="Amount (local currency)"
            :value="transactionKey('local_amount')"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Date (created at)" :value="transactionKey('created_at')" type="date">
          </key-value>
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Started At" :value="transactionKey('started_at')" type="date" />
        </v-col>
        <v-col cols="12" md="2">
          <key-value title="Done At" :value="transactionKey('done_at')" type="date" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  components: {},
  props: {
    dataTransaction: {
      required: true,
    },
    title: { default: 'Reward Details' }
  },
  data() {
    return {
      loading: true,
      customerReward: this.dataTransaction,
      isArchived: this.dataTransaction.isArchived || false,
      isArchiving: false,
      isRestoring: false,
      isRetrying: false,
    };
  },
  computed: {
    rewardIsStuck() {
      const status = this.transactionKey("status");
      if (status === "started" || status === "error") {
        return true;
      }
      return false;
    },
  },
  methods: {
    transactionKey(key, defaultValue = null) {
      return this.extractDataKey(this.customerReward, key, defaultValue);
    },
    retryReward() {
      this.isRetrying = true;
      this.$http
        .put(`api/v1/transactions/campaignReferralRewards/${this.transactionKey("id")}`)
        .then(({ status }) => {
          Notify.success(status);
          this.$router.push({ name: "customerRewards.index" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRetrying = false));
    },
  },
};
</script>
